import { useMemo, useState, type ReactElement } from 'react'
import { isEmpty, searchIncludes, type TeamData } from '@terros/common'
import { Text, TextInput } from '@mantine/core'
import { useTranslation, type DashboardAudienceTarget } from '@front/model'
import { PrefetchedTeamInfo } from '@components'
import { AudienceOptionList, AudienceOptionRow } from './AudienceOptionList'

type Props = {
  teams: TeamData[]
  selectedTarget: DashboardAudienceTarget | undefined
  onSelect: (target: DashboardAudienceTarget) => void
}

export function AudienceTeamOptions({ teams, selectedTarget, onSelect }: Props): ReactElement {
  const { t } = useTranslation()
  const [search, setSearch] = useState('')
  const filteredTeams = useMemo(() => {
    const query = search.trim()
    if (isEmpty(query)) return teams
    return teams.filter((team) => searchIncludes([team.name], query))
  }, [search, teams])

  return (
    <>
      <TextInput
        placeholder={t('Search teams')}
        value={search}
        onChange={(event) => setSearch(event.currentTarget.value)}
      />
      <AudienceOptionList>
        {filteredTeams.map((team) => (
          <AudienceOptionRow
            isSelected={selectedTarget?.entityId === team.teamId}
            key={team.teamId}
            onSelect={() => onSelect({ entityId: team.teamId, name: team.name })}
          >
            <PrefetchedTeamInfo linked={false} size='sm' team={team} />
          </AudienceOptionRow>
        ))}
        {isEmpty(filteredTeams) && <Text c='dimmed'>{t('No teams found')}</Text>}
      </AudienceOptionList>
    </>
  )
}
